import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-email-fill",
  "use": "icon-email-fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-email-fill\">\n  <path d=\"M993.882353 271.058824l-481.882353 240.941176-481.882353-240.941176v-120.470589h963.764706v120.470589z\" fill=\"currentColor\" p-id=\"1570\" />\n  <path d=\"M30.117647 331.294118v542.117647h963.764706v-542.117647l-481.882353 240.941176-481.882353-240.941176z\" fill=\"currentColor\" p-id=\"1571\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol